import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { blobToFile } from "../../utils";
import service from "../resources/service";
import { fetchResource } from "../resource/slice";
import adapter from "./adapter";

const NAME = "resourceForm"

const initialState = {
  _payload: null,
  status: "idle",
  error: "",
  data: getInitialForm(),
};

export const updateImage = createAsyncThunk(
  `${NAME}/updateImage`,
  async (options) => {
    const {id, data, key} = options
    return new Promise((resolve, reject) => {
      const {name, type, blob} = data

      console.log('update image data before blobtofile:', data)

      blobToFile(blob, name, type).then((file) => {
        console.log('resource form updateImage action from slice, file data:', file)
        const formData = new FormData()
        formData.append(key, file)

        const requestBody = {id, formData}

        service.updateResourceImage(requestBody)
        .then(res => resolve(res))
        .catch(err => reject(err))
      })
    })
  }
);

export const resourceFormSlice = createSlice({
  name: NAME,
  initialState,
  reducers: {
    setStatus(state, action){
      state.status = action.payload
    },
    updateForm(state, action){
      state.data[action.payload.key] = action.payload.value
    },
    reset(state){
      state.data = getInitialForm()
    },
  },
  extraReducers: {
    [fetchResource.fulfilled]: (state, action) => {
      state._payload = action.payload
      /**
       * @warning response from backend is not stable. it may be an array of objects, not directly the object
       */
      const resource = action.payload.results
      const form = adapter.responseBodyToForm(resource)
      const data = {
        ...state.data,
        ...form,
        _file: form.file
      }
      state.data = data
    },
  }
});

export const {
  setStatus,
  updateForm,
  reset,
} = resourceFormSlice.actions

export default resourceFormSlice.reducer;

// Helpers
function getInitialForm(){
  return {
    id: 0,
    title_en: '',
    title_id: '',
    type: 'embed',
    about_en: 'N/A',
    about_id: 'N/A',
    visibility: 'public',
    suitable: [],
    tags: [],
    image: null,
    thumbnail: null,
    file: {
      type: 'embed',
      embed_link: ''
    }
  }
}
